import { generateUniqueTabId } from './util';

export const tabId = generateUniqueTabId();

export const BROADCAST_CHANNEL_ID = 'broadcast-channel';
